import React from "react";
import styles from "./map-buttons.module.scss";
const LayersSvg = props => (
    <svg className={styles.nswSvg} width={35} viewBox="0 0 24 24" cursor="pointer">
        <path
            d="M11.99 18.54l-7.37-5.73L3 14.07l9 7 9-7-1.63-1.27-7.38 5.74zM12 16l7.36-5.73L21 9l-9-7-9 7 1.63 1.27L12 16z"
            fillRule="evenodd"
        />
    </svg>
);

export default LayersSvg;



// WEBPACK FOOTER //
// ./src/components/ui/map-buttons/layers-svg.js